import { generateMTTReducer } from '@swf/poker';

import { SundayMillionTab } from '../types';

import { defaultState, satelliteActiveFilters } from './defaultState';
import type { PokerSundayMillionState } from './types';

export const reducers = {
  ...generateMTTReducer<PokerSundayMillionState>(defaultState),
  setSelectedTab: (
    state: PokerSundayMillionState,
    { selectedTab }: { selectedTab: SundayMillionTab }
  ): PokerSundayMillionState => ({
    ...defaultState,
    isHydrated: state.isHydrated,
    selectedTab,
    activeFilters:
      selectedTab === SundayMillionTab.Main ? defaultState.activeFilters : satelliteActiveFilters
  }),
  setIsHydrated: (state: PokerSundayMillionState) => ({ ...state, isHydrated: true })
};
